var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseRenderer',{class:[
        'c-flex',
        _vm.spacingXClass,
        _vm.justifyClass,
        _vm.alignItemsClass,
        _vm.inline ? 'flex-inline' : 'flex',
        _vm.wrap ? 'flex-wrap' : ''
    ],attrs:{"wrapper":"div","child-tag-name":"BaseFlexItem","child-data":{
        props: _vm.childProps
    }}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }